// extracted by mini-css-extract-plugin
module.exports = {"filters":"filters--3ar4b","item":"item--1jfyp","voivodeship":"voivodeship--XIrnx","settlementPeriod":"settlementPeriod--18mRo"};